<template>
  <div class="order-wrapper">
    <portal target-el="#filter">
      <Breadcrumb
        back="Invoice"
        title="Wallet"/>
    </portal>
    <div>
      <Header />
      <span v-if="!isLoading && walletList.length === 0">No Data available</span>
      <div class="fixed-row top-sm" v-else
        v-infinite-scroll="loadData"
        infinite-scroll-disabled="loadCheck"
        infinite-scroll-throttle-delay="400"
        infinite-scroll-distance="10">
        <Row
          v-for="wallet in walletList"
          v-bind:key="wallet.transporter_id"
          :wallet="wallet" />
      </div>
    </div>
  </div>
</template>

<script>
import Header from './header';
import Row from './row';
import Breadcrumb from './breadcrumb';
import { mapGetters } from 'vuex';
import debounce from 'debounce';

export default {
  components: {
    Breadcrumb,
    Header,
    Row,
  },
  data() {
    return {
      loadCheck: true,
    };
  },
  computed: {
    ...mapGetters({
      isLoading: 'wallet/isLoading',
      walletList: 'wallet/list',
      page: 'wallet/page',
      hasEmpty: 'wallet/hasEmpty',
    }),
  },

  async created() {
    this.$store.commit('wallet/initData');
    this.loadData();
  },

  methods: {
    async loadData() {
      try {
        const result = await this.$store.dispatch('wallet/list', { page: this.page });
        if (result.error) {
          this.$errorMessage({ message: result.error });
        }
        this.loadCheck = this.hasEmpty;
      } catch (e) {
        this.$errorMessage({ message: this.$getErr('LISTING_FAILS') });
      }
    },
  },
};
</script>
<style lang='scss'>
.fixed-row {
  position: fixed;
  padding-right: 10px;
  top: 170px;
  left: 20px;
  right: 10px;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  &.top-sm {
    top: 170px !important;
  }
}
</style>
